import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import * as React from 'react';
import { FeatureFlag, useFeatureFlag } from 'utils/permissions/feature-flags';

export const enum Proof {
  All = 'all',
  ReturnsOnly = 'returns_only',
}

interface Props {
  selected: Proof;
  onSelect: (proof: Proof) => void;
}

export const Proofs: React.FC<Props> = (props) => {
  const { selected, onSelect } = props;
  const smartPerDiemApptScreenshots = useFeatureFlag(FeatureFlag.SmartPerDiemApptScreenshots);

  const proofs = React.useMemo(() => {
    return [
      {
        proof: Proof.All,
        details: ['BlueCargo return locations', 'Empty receiving schedule'].concat(
          smartPerDiemApptScreenshots ? ['Appts screenshots'] : []
        ),
      },
      { proof: Proof.ReturnsOnly, details: ['BlueCargo return locations only'] },
    ];
  }, [smartPerDiemApptScreenshots]);

  return (
    <ToggleButtonGroup
      value={selected}
      onChange={(_, proof) => {
        if (proof === null) {
          return;
        }
        onSelect(proof);
      }}
      exclusive
      className="pt-4 gap-4"
    >
      {proofs.map((p) => (
        <ToggleButton
          key={p.proof}
          value={p.proof}
          size="small"
          classes={{
            root: 'text-left font-normal text-gray-600 border border-gray-50 px-1 py-3',
            selected: 'text-blue-900 bg-blue-100 ',
          }}
        >
          <ul className="list-disc mx-6 leading-snug">
            {p.details.map((detail) => (
              <li key={detail}>{detail}</li>
            ))}
          </ul>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};
Proofs.displayName = 'SmartPerDiem.DownloadModal.Proofs';
